module.exports = __webpack_public_path__ + "static/media/allowed.0c385c31.svg";